import React, { useMemo } from 'react';
import classNames from 'classnames';
import { ListingCard, PrimaryButton } from '../../../components';
import Slider from 'react-slick';
import Icons from '../../../components/Icons/Icons';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import css from './Section.module.css';
import '../../../styles/slick/slick-theme.css';
import '../../../styles/slick/slick.css';

function ExploreAmazingChef(props) {
  const { intl, sliderSettings: sliderSettingsProp, listings, user } = props;

  // Clone slider settings so we can safely mutate for mobile
  const sliderSettings = useMemo(() => ({ ...(sliderSettingsProp || {}) }), [sliderSettingsProp]);
  const isWindowDefined = typeof window !== 'undefined';
  const isMobileLayout = isWindowDefined && window.innerWidth < 768;
  const history = useHistory();

  if (isMobileLayout) {
    Object.assign(sliderSettings, { dots: false });
  }


  return (
    <div className={classNames(css.popularSessions, css.amazingChefs)}>
      <div className={css.amazingChefsContent}>
        <div className={css.sectionHead}>
          <div className={css.fixedWidthContainer}>
            <h2>{intl.formatMessage({ id: 'ExploreAmazingChef.title' })}</h2>
            <p>{intl.formatMessage({ id: 'ExploreAmazingChef.description' })}</p>
          </div>
        </div>
        <div className={css.listingSlider}>
          <div className={css.fixedWidthContainer}>
            {/* {listings.map(l => (
            <ListingCard
              className={css.listingCard}
              key={l?.id?.uuid}
              listing={l}
              setActiveListing={() => {}}
            />
          ))} */}
            <Slider {...sliderSettings}>
              {listings.flatMap(l =>
                Array(8)
                  .fill()
                  .map((_, i) => (
                    <ListingCard
                      user={user}
                      className={css.listingCard}
                      key={l?.id?.uuid + '_x' + i}
                      listing={l}
                      setActiveListing={() => {}}
                    />
                  ))
              )}
            </Slider>
            <div className={css.findMore}>
              <PrimaryButton onClick={() => history.push('/s')}>
                {intl.formatMessage({ id: 'ExploreAmazingChef.findLocalChef' })} <Icons name="rightAngle" />
              </PrimaryButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ExploreAmazingChef.defaultProps = {
  sliderSettings: {
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 2000,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    variableWidth: false,
    focusOnSelect: false,
    centerMode: false,
    responsive: [
      { breakpoint: 1500, settings: { slidesToShow: 4 } },
      { breakpoint: 1300, settings: { slidesToShow: 4 } },
      { breakpoint: 992, settings: { slidesToShow: 3 } },
      { breakpoint: 580, settings: { slidesToShow: 2, arrows: false } },
      { breakpoint: 480, settings: { slidesToShow: 1.5 } },
    ],
  },
};

export default ExploreAmazingChef;